import { SelectOneValue } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { DynamicSchemaDefinitionSelectOne } from '../../../../../generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionSelectOne, 'choices' | 'label'>;
  value: SelectOneValue;
  className?: string;
}

const AsSelection = ({ field, value, className }: Props & ClassAttributes<HTMLElement>) => {
  const correspondingChoice = field.choices.find((c) => c.key === value);

  if (!correspondingChoice) {
    return null;
  }

  return (
    <Base field={field} className={className}>
      <Typography variant="body2">{correspondingChoice.label}</Typography>
    </Base>
  );
};

export default AsSelection;
